var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEquinox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 865.94 260.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:url(#linear-gradient-20);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{fill:url(#linear-gradient-22);}.cls-23{fill:url(#linear-gradient-23);}.cls-24{fill:url(#linear-gradient-24);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 49.37,
    y1: 220.3,
    x2: 49.37,
    y2: 2.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00001f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001c54"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 182.15,
    y1: 220.3,
    x2: 182.15,
    y2: 2.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 320.31,
    y1: 220.3,
    x2: 320.31,
    y2: 2.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 408.12,
    y1: 220.3,
    x2: 408.12,
    y2: 2.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 494.71,
    y1: 220.3,
    x2: 494.71,
    y2: 2.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 637.92,
    y1: 220.3,
    x2: 637.92,
    y2: 2.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 774.63,
    y1: 220.3,
    x2: 774.63,
    y2: 2.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 30.61,
    y1: 220.31,
    x2: 30.61,
    y2: 2.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 506.81,
    y1: 20.93,
    x2: 897.21,
    y2: 411.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b1802c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#dfbe61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#f6dd7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fff2a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#b1802c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#b88a36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#ebd485"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fff2a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#f6dd7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b1802c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 476.14,
    y1: 48.88,
    x2: 866.54,
    y2: 439.28,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -12.11,
    y1: 137.1,
    x2: 523.7,
    y2: 338.69,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 562.79,
    y1: 264.53,
    x2: 562.79,
    y2: 11.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 614.27,
    y1: 264.53,
    x2: 614.27,
    y2: 11.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 665.17,
    y1: 264.53,
    x2: 665.17,
    y2: 11.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 714.98,
    y1: 264.53,
    x2: 714.98,
    y2: 11.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 762.99,
    y1: 264.53,
    x2: 762.99,
    y2: 11.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 809.65,
    y1: 264.53,
    x2: 809.65,
    y2: 11.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 856.43,
    y1: 264.53,
    x2: 856.43,
    y2: 11.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 712.52,
    y1: 219.52,
    x2: 712.52,
    y2: 11.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 668.7,
    y1: 219.52,
    x2: 668.7,
    y2: 11.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 595.26,
    y1: 219.53,
    x2: 595.26,
    y2: 11.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 664.79,
    y1: 219.52,
    x2: 664.79,
    y2: 11.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 622.71,
    y1: 219.52,
    x2: 622.71,
    y2: 11.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 667.57,
    y1: 219.52,
    x2: 667.57,
    y2: 11.58,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,217.84V107.4H98.59v19.29H19.14v71.86H98.75v19.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.51,217.84l-7.6-6.53a58.65,58.65,0,0,1-12.38,4.78,54,54,0,0,1-13.9,1.75H165.74a52.12,52.12,0,0,1-21.34-4.33,52.56,52.56,0,0,1-28.26-29.7,60.81,60.81,0,0,1-4-22.33,58.89,58.89,0,0,1,4-22.18,49.25,49.25,0,0,1,11.24-17.09,50.54,50.54,0,0,1,17-10.94,57.55,57.55,0,0,1,21.34-3.87h26.89a58.84,58.84,0,0,1,22,3.95,48.91,48.91,0,0,1,28.18,28.18,59,59,0,0,1,4,21.95,60.91,60.91,0,0,1-4,22.41,54,54,0,0,1-11.31,17.85l20.81,16.1ZM170.3,172.26h25.52l20.51,17.32a34.5,34.5,0,0,0,8.12-11.85,41.1,41.1,0,0,0,.38-29.7,32.46,32.46,0,0,0-18.23-18.68,36,36,0,0,0-14-2.66H165.74A35.07,35.07,0,0,0,152,129.35a32.5,32.5,0,0,0-10.86,7.37A33.85,33.85,0,0,0,134,148a39,39,0,0,0-2.58,14.43A39.68,39.68,0,0,0,134,176.82a34.28,34.28,0,0,0,7.14,11.47A32.89,32.89,0,0,0,152,195.81a34.24,34.24,0,0,0,13.75,2.74h26.89a39.37,39.37,0,0,0,9.57-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M361.1,107.4h18.84v61.67a67.28,67.28,0,0,1-3.34,22.26,36.53,36.53,0,0,1-10.49,15.72q-7.14,6.24-18.45,9.27t-27.42,3q-16,0-27.27-3t-18.46-9.27A36.42,36.42,0,0,1,264,191.33a67,67,0,0,1-3.34-22.26V107.4h19.9v61.67a43.86,43.86,0,0,0,2.05,14.29,21.26,21.26,0,0,0,6.68,9.72,29.49,29.49,0,0,0,12.38,5.54,105.54,105.54,0,0,0,38.28,0,29.54,29.54,0,0,0,12.39-5.54,21.41,21.41,0,0,0,6.68-9.72,43.86,43.86,0,0,0,2.05-14.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M398.47,217.84V107.4h19.29V217.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M455.9,137v80.82H437.52V117.58q0-5.33,2.65-8.43a9,9,0,0,1,7.22-3.12,9.64,9.64,0,0,1,4.1.91,14.7,14.7,0,0,1,4.1,3l77.93,77.32V106.49h18.39V207.66c0,3.65-.89,6.48-2.66,8.51a8.79,8.79,0,0,1-6.92,3q-4.71,0-8.81-4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M623.94,218.12a53.4,53.4,0,0,1-21.82-4.43,53.78,53.78,0,0,1-28.89-30.36,62.4,62.4,0,0,1-4.12-22.83,60.47,60.47,0,0,1,4.12-22.68,50.25,50.25,0,0,1,11.49-17.47,51.86,51.86,0,0,1,17.4-11.18,58.83,58.83,0,0,1,21.82-4h27.49a60.38,60.38,0,0,1,22.44,4,50,50,0,0,1,28.81,28.81,60.34,60.34,0,0,1,4,22.44,62.19,62.19,0,0,1-4.12,22.83,54.85,54.85,0,0,1-11.49,18.24,54,54,0,0,1-17.47,12.12,54.78,54.78,0,0,1-22.21,4.43Zm27.49-19.73a36,36,0,0,0,14.29-2.79,33.71,33.71,0,0,0,18.63-19.42A40.55,40.55,0,0,0,687,161.43a40,40,0,0,0-2.64-14.68,33.15,33.15,0,0,0-18.63-19.1,36.86,36.86,0,0,0-14.29-2.72H623.94a35.85,35.85,0,0,0-14.06,2.72,33.27,33.27,0,0,0-11.1,7.53,34.56,34.56,0,0,0-7.3,11.49,39.88,39.88,0,0,0-2.64,14.76,40.55,40.55,0,0,0,2.64,14.75,35,35,0,0,0,7.3,11.73,33.83,33.83,0,0,0,11.1,7.69,35,35,0,0,0,14.06,2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M819.75,219.28l-46.33-45.12-45.88,45.12H702.48l59.24-57.43-55-53h26.58l42.08,40.87,41.48-40.87h25.06l-55,53,59.85,57.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    y: 153.58,
    width: 61.22,
    height: 16.26
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M589.3,85.41s-22.27-4.07-31,10.65a20.78,20.78,0,0,1-4.06,3.68S533,117.17,528.1,131.31c0,0,12.59,9.68,40.28,7,0,0,4.84-6,11.62-8.52,0,0-17.23,13.75-14.91,37.57a26.85,26.85,0,0,1-7.75,18.59s-1.45-2,1.36-3.68c0,0-8.52-6.58-9.68.58,0,0,.19,22.66-11.62,36.41H561s-.19-7.35-3.48-10.26c0,0-1.94-.58,1.16-6.78L562,195l-3.3-2.52s11.24,2.12,16.66.77c0,0,5,0,7.16-4.45,0,0,11.62-33.7,24.21-45.51A75.46,75.46,0,0,0,598,172.75s17.43-6.77,33.89-.77c0,0-6.2-8.33-4.85-22.08a71.87,71.87,0,0,0,24.41,32.73l12.39,22.85s2.33,2.33-2.32,13.75h24.4a21,21,0,0,0-9.68-13.36,19.79,19.79,0,0,1-4.26-5.62l-6.39-16.84s-1.36-5.43.38-9.3c0,0,5.23-18.4-5.22-42,0,0,12.39,12.78,14.13,44.74,0,0,26.15-14.33,30.41-45.51,0,0,2.71,15.88-9.49,36.41,0,0,5.35,3.87,9.75,15.1l8.65,21.5s3.1,5-1.36,14.91h21.89a18.08,18.08,0,0,0-8.14-12.59l-10.26-27.3s2.51-24.79-9.3-57.52c0,0,4.26-24-24.4-59.26,0,0-4.84,4.45-20.92,2.32,0,0,14.72-.58,21.69-11.43,0,0-9.87,2.32-14.91-1.93l-7.74,2.9A65.29,65.29,0,0,0,681.68,33.7s3.1-4.26-4.45-9.69c0,0-24.21-11.23-32.54-24,0,0,1.74,11.62,10.46,20l6.58,5.42s5.72,3.55,4.46,14.91c0,0-3.1-3.68-2.91-6.19,0,0-1.35,4.07-12.2,7.36,0,0-7.35,3.29-3.87,11.81,0,0-4.84-2.71-2.91-9.49,0,0-10.27-.39-17.62,10.07,0,0-10.85,3.49-14.14-.19a5.43,5.43,0,0,0-2.32,3.68,16,16,0,0,0-3.49-11s-7.55-13-21.3-19c0,0,14.52,15.88,17,29.24,0,0,1.94,9.3,6.59,9.88,0,0,8.13,1.74,9.29,3.29a16.75,16.75,0,0,1,4.75-11.13s-2.62,4.5-1.46,12.49c0,0-4.94,7.7-11.76,12.34,0,0-2.32,2,.14,4.79a37.83,37.83,0,0,0,12.21,9.16s3.34,2,5.37-2.33c0,0,6.53-6,11.47-6.53,0,0,9.59-1.46,11.77-6.69,0,0,1.45,6.25-10.89,9.74,0,0,4.79,15.1-17.87,23.24,0,0-24.4,5.66-37.76,11.18a103.94,103.94,0,0,1-26.44,3.63s-14.38,1-23-4.21l3.05-1.16s13.36-25.86,37.18-35.44c0,0-10.89,7.84-13.5,10.89,0,0,9.43,1,13.36-5.08A25.38,25.38,0,0,1,589.3,85.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M622.71,203.35l-7.65-13.95s6.9-1.35,14.1-3.54c5-1.51,10.12-3.42,13.21-5.56,0,0-10.07-9.88-28.47-8.91,0,0-6,11.62-13.75,16.07,0,0,10.65,10.07,12,16.27a19.89,19.89,0,0,1-3.2,12.79H632.1a10.1,10.1,0,0,0-.83-5.13C630.18,208.81,627.8,205.73,622.71,203.35Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    y: 237.97,
    width: 534.4,
    height: 8.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M551.5,260.17V238h7.07l4.24,15.16L567,238h7.09v22.22H569.7V242.68l-4.64,17.49h-4.55l-4.62-17.49v17.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M626,260.17h-5.13l-2-5.05h-9.35l-1.93,5.05h-5L611.65,238h5Zm-8.69-8.79-3.22-8.24-3.16,8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M654.66,260.17V238h9.94a17.74,17.74,0,0,1,5.44.6,5.36,5.36,0,0,1,2.73,2.13,6.17,6.17,0,0,1,1,3.5,5.75,5.75,0,0,1-1.55,4.13,7.63,7.63,0,0,1-4.63,2.06,10.63,10.63,0,0,1,2.53,1.86,25.28,25.28,0,0,1,2.69,3.61l2.86,4.33H670l-3.41-4.83a31.62,31.62,0,0,0-2.5-3.27,3.5,3.5,0,0,0-1.42-.92,8,8,0,0,0-2.37-.25h-1v9.27Zm4.72-12.82h3.49a19.24,19.24,0,0,0,4.25-.27,2.56,2.56,0,0,0,1.32-.94,2.79,2.79,0,0,0,.48-1.67,2.57,2.57,0,0,0-.63-1.81,2.93,2.93,0,0,0-1.78-.87c-.38,0-1.53-.08-3.44-.08h-3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M704.44,260.17V238h4.72v9.87L718.7,238h6.35l-8.81,8.66,9.29,13.56h-6.11L713,249.75l-3.83,3.71v6.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M754.1,260.17V238h17.34v3.76H758.82v4.93h11.74v3.74H758.82v6.05h13.07v3.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M807.29,260.17V241.71h-6.93V238h18.58v3.76H812v18.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M846.93,252.94l4.59-.42a4.64,4.64,0,0,0,5.1,4.26,5.45,5.45,0,0,0,3.44-.92,2.7,2.7,0,0,0,1.16-2.15,2,2,0,0,0-.49-1.34,4,4,0,0,0-1.7-1c-.55-.18-1.81-.5-3.78-1a13.07,13.07,0,0,1-5.33-2.2,5.67,5.67,0,0,1-2.15-4.47,5.52,5.52,0,0,1,1-3.17,6.25,6.25,0,0,1,2.92-2.25,12.17,12.17,0,0,1,4.6-.77q4.41,0,6.63,1.83a6.3,6.3,0,0,1,2.34,4.89l-4.72.2a3.76,3.76,0,0,0-1.3-2.46,5,5,0,0,0-3-.75,5.61,5.61,0,0,0-3.23.8,1.59,1.59,0,0,0-.74,1.38,1.66,1.66,0,0,0,.7,1.35,13,13,0,0,0,4.33,1.49,23.53,23.53,0,0,1,5.1,1.59,6.56,6.56,0,0,1,2.59,2.26,6.37,6.37,0,0,1,.93,3.54,6.28,6.28,0,0,1-1.12,3.58,6.5,6.5,0,0,1-3.16,2.47,13.78,13.78,0,0,1-5.08.82q-4.44,0-6.81-1.95A8.26,8.26,0,0,1,846.93,252.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M716.62,179.34s1.56-15.34-3.53-37.82c-1.2,6.52-2.85,13.53-4.89,17.87C708.2,159.39,713.72,164.13,716.62,179.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M692.8,76.16c-3.69,4.49-19,.73-19,.73-29.43-4.65-44,14.33-44,14.33S657,63.91,694.55,87.73c0,0,18.78,9.49,6,39.71a18.14,18.14,0,0,1-4.29-10.08c.39,10.14.56,41-11,51.86,7.86-7.21,17.84-19.67,20.33-37.91a79.69,79.69,0,0,1,1.74-9.49S710.5,103.84,692.8,76.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M565.37,167.33s0,.56,0,1.5c1.15-21.84,23.49-30.94,23.49-30.94,10.45-13.36,36.53-24.27,36.53-24.27l0,0c-1,.41-1.94.82-3,1.2,0,0-23.1,5.36-36.66,10.74a20.28,20.28,0,0,1-5.42,4.22S563,143.51,565.37,167.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M662,163.65s2.88,4.46,3.38,15.69h0a12.25,12.25,0,0,1,.88-5.23s3.92-13.82-1.84-32.88A77.28,77.28,0,0,1,662,163.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M622.71,206.06l-7.65-13.94s6.9-1.35,14.1-3.54a18.4,18.4,0,0,1,4.11-6.92S622,191,612.16,191c0,0,7,11.81,8.91,16.07a19.55,19.55,0,0,1,10.2,7.08C630.18,211.53,627.8,208.45,622.71,206.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M668.23,21.84s13,6.45,7.52,19.62a62,62,0,0,0,5.74-7.76S684.58,29.44,677,24c0,0-13.67-6.34-24-14.92C655.33,12.5,659.77,16.85,668.23,21.84Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquinox);
export default __webpack_public_path__ + "static/media/equinox.1c48d9ae30284e4f91649e5acf3deb9c.svg";
export { ForwardRef as ReactComponent };